import React from "react";
import Card from 'react-bootstrap/Card';

const resultPanel01Style = {
    position: "absolute",
    right: "40px",
    top: "0px",
    margin: "1em",
    zIndex: 100,
    width: "200px",
    height:"200px"
}

const resultPanel02Style = {
    position: "absolute",
    right: "40px",
    top: "210px",
    margin: "1em",
    zIndex: 100,
    width: "200px",
    height:"200px"
}

const resultPanelBodyStyle = {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column"
}
const ResultPanel = ({commuterNum,commuterType, direction, unitNum, unitType}) => {
    return (
        <>
        <Card style={resultPanel01Style} className="text-lg-center">
            <Card.Body style={resultPanelBodyStyle}>
                <Card.Text className="h1">{commuterNum}</Card.Text>
                <Card.Text className="h5">{commuterType}</Card.Text>
            </Card.Body>
        </Card>
        <Card style={resultPanel02Style} className="text-lg-center">
            <Card.Body style={resultPanelBodyStyle}>
                <Card.Text className="h5">{commuterNum > 1 ? "pendeln" : "pendelt" } {direction}</Card.Text>
                <Card.Text className="h1">{unitNum}</Card.Text>
                <Card.Text className="h5">{unitType}</Card.Text>
            </Card.Body>
        </Card>
        </>
    )
}

export default ResultPanel;